module.exports = __webpack_public_path__ + "img/image3.f069a4c2.jpg";